import React, { useEffect } from "react";
import "./LanguageModal.css";

const flagUrls = {
  es: "https://cdn-icons-png.flaticon.com/512/197/197593.png",
  en: "https://cdn-icons-png.flaticon.com/512/197/197374.png",
  de: "https://cdn-icons-png.flaticon.com/512/197/197571.png",
  fr: "https://cdn-icons-png.flaticon.com/512/197/197560.png",
  it: "https://cdn-icons-png.flaticon.com/512/197/197626.png",
  pt: "https://cdn-icons-png.flaticon.com/512/197/197463.png",
  nl: "https://cdn-icons-png.flaticon.com/512/197/197441.png",
  ru: "https://cdn-icons-png.flaticon.com/512/197/197408.png",
};

const LanguageModal = ({ title, icon, links, onClose }) => {
  useEffect(() => {
    const languages = Object.entries(links);
    if (languages.length === 1) {
      // Si solo hay un idioma, redirige automáticamente
      const [, url] = languages[0];
      window.open(url, "_blank", "noopener,noreferrer");
      onClose(); // Cierra el modal automáticamente si fuera necesario
    }
  }, [links, onClose]);

  const languages = Object.entries(links);
  if (languages.length === 1) return null; // No renderiza el modal si ya se redirigió

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div className="modal-overlay" onClick={onClose}>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <h2>
          <i className={icon} /> {title}
        </h2>
        <div className="flags">
          {languages.map(([language, url]) => (
            <a
              key={language}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="flag-link"
              onClick={onClose}
            >
              <img
                src={flagUrls[language]}
                alt={language}
                className="flag-icon"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
